export default {
  setPopupPersonality: ({ commit }, payload) => {
    commit('SET_POPUP_PERSONALITY', payload)
  },
  setPreviousLanguage: ({ commit }, payload) => {
    commit('SET_PREVIOUS_LANGUAGE', payload)
  }
}
